//component
import Container from "../../../components/element/container";
import Input from "../../../components/element/input";
import Col from "../../../components/element/col";
import Row from "../../../components/element/row";
import Icon from "../../../components/element/icon";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Field, Form, Formik } from "formik";
import {
  checkout,
  getPaymentList,
  setState,
} from "../../../redux/reducer/cart.reducer";
import { showToast } from "../../../helpers/show.toast";
import { handleCatchError } from "../../../helpers/handle.catch.error";
import Button from "../../../components/element/button";
import { useEffect, useState } from "react";
import { Skeleton } from "primereact/skeleton";
import {
  closeFullLoading,
  openFullLoading,
} from "../../../redux/reducer/common.reducer";
import { openLoginModal } from "../../../redux/reducer/modal.reducer";
import Dropdown from "../../../components/element/dropdown";

export default function CartForm() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token, username } = useSelector((state) => state.common);
  const {
    cartInfo,
    cartInfoLoading,
    paymentList,
    paymentListLoading,
    checkoutLoading,
  } = useSelector((state) => state.cart);

  const [expandPayment, setExpandPayment] = useState([]);
  const [paymentName, setPaymentName] = useState("");

  const stateOptions = [
    { label: "Selangor", value: "Selangor" },
    { label: "Kuala Lumpur", value: "Kuala Lumpur" },
    { label: "Penang", value: "Penang" },
    { label: "Pahang", value: "Pahang" },
    { label: "Perak", value: "Perak" },
    { label: "Johor", value: "Johor" },
    { label: "Melaka", value: "Melaka" },
    { label: "Negeri Sembilan", value: "Negeri Sembilan" },
    { label: "Perlis", value: "Perlis" },
    { label: "Kedah", value: "Kedah" },
    { label: "Kelantan", value: "Kelantan" },
    { label: "Terengganu", value: "Terengganu" },
    { label: "Sabah", value: "Sabah" },
    { label: "Sarawak", value: "Sarawak" },
    { label: "Labuan", value: "Labuan" },
    { label: "Putrajaya", value: "Putrajaya" },
  ];

  const formList = [
    {
      label: "Shipping Information",
      description: (
        <p>
          Please enter your exact contact number so we can contact you during
          shipping.{" "}
          {!(token && username) && (
            <>
              If you are a member, please{" "}
              <span className="pointer" onClick={() => handleLogin()}>
                Login
              </span>{" "}
              to stay updated on your order status and track your previous
              shipping details.
            </>
          )}
        </p>
      ),
      form: [
        { label: "Name *", name: "name", component: Input, type: "col-2" },
        {
          label: "Contact No. *",
          name: "contact",
          prefix: "+60",
          component: Input,
          type: "col-2",
        },
        // {
        //   label: "Email Address *",
        //   name: "email",
        //   component: Input,
        //   type: "col-2",
        // },
        {
          label: "Country *",
          name: "country",
          component: Input,
          type: "col-2",
          readOnly: true,
        },
        {
          label: "Address *",
          name: "address",
          component: Input,
          type: "col-1",
        },
        {
          label: "Postcode *",
          name: "postcode",
          component: Input,
          type: "col-3",
        },
        { label: "City *", name: "city", component: Input, type: "col-3" },
        {
          label: "State *",
          name: "state",
          component: Dropdown,
          options: stateOptions,
          type: "col-3",
        },
        {
          label: "Delivery Instruction (Optional)",
          name: "delivery_instruction",
          as: "textarea",
          component: Input,
          type: "col-1",
        },
      ],
    },
    {
      label: "Payment Method",
      description: <p>All transactions are secure and encrypted.</p>,
      form: [
        { label: "Credit Card" },
        { label: "Online Banking" },
        {
          label: "E-wallet",
          method: [
            { label: "Boost" },
            { label: "Touch N' Go" },
            { label: "Grab Pay" },
          ],
        },
      ],
    },
  ];

  const shippingForm = formList[0].form;

  const inputList = [
    shippingForm.slice(0, 1),
    shippingForm.slice(1, 3),
    shippingForm.slice(3, 4),
    shippingForm.slice(4, 7),
    shippingForm.slice(7, 8),
  ];

  const checkoutForm = {
    name: cartInfo?.properties?.fullName ?? "",
    contact: cartInfo?.properties?.phone?.startsWith("+60")
      ? cartInfo?.properties?.phone.slice(3)
      : "",
    address: cartInfo?.properties?.address ?? "",
    postcode: cartInfo?.properties?.zip ?? "",
    city: cartInfo?.properties?.city ?? "",
    state: cartInfo?.properties?.state ?? "Kuala Lumpur",
    country: cartInfo?.properties?.country ?? "Malaysia",
    delivery_instruction: "",
    tenant_channel_id: "",
    provider_channel_id: "",
    payment_method_name: "",
  };

  const checkoutSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    contact: Yup.string()
      .matches(/^(11\d{7,8}|1[0-9]\d{7})$/, "Please enter a valid phone number")
      .required("Contact no. is required"),
    address: Yup.string().required("Address is required"),
    postcode: Yup.string().required("Postcode is required"),
    city: Yup.string().required("City is required"),
    state: Yup.string().required("State is required"),
    country: Yup.string().required("Country is required"),
    payment_method_name: Yup.string().required("Payment method is required"),
  });

  const handleLogin = () => {
    dispatch(openLoginModal());
  };

  const handleSubmit = (values, setFieldError) => {
    dispatch(openFullLoading());

    dispatch(
      checkout({
        properties: {
          delivery_info: {
            fullName: values.name,
            address: values.address,
            city: values.city,
            state: values.state,
            zip: values.postcode,
            country: values.country,
            phone: `+60${values.contact}`,
            deliveryInstructions: values.delivery_instruction,
          },
        },
        tenant_channel_id: values.tenant_channel_id,
        provider_channel_id: values.provider_channel_id,
        payment_method_name: values.payment_method_name,
      })
    )
      .unwrap()
      .then((res) => {
        if (res.data?.payment_data?.result?.url) {
          window.parent.location.replace(res.data.payment_data.result.url);
        }
      })
      .catch((ex) => {
        dispatch(closeFullLoading());
        handleCatchError(ex, null);
      });
  };

  const handleExpandPayment = (index) => {
    setExpandPayment((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const handleSelectPayment = (payment, setFieldValue) => {
    if (Array.isArray(payment)) {
      setFieldValue("provider_channel_id", "");
      setFieldValue("tenant_channel_id", payment[0].tenant_channel_id);
      setFieldValue("payment_method_name", payment[0].display_name);
    } else {
      setFieldValue("provider_channel_id", payment.provider_channel_id);
      setFieldValue("tenant_channel_id", payment.tenant_channel_id);
      setFieldValue("payment_method_name", payment.display_name);
    }
  };

  useEffect(() => {
    dispatch(getPaymentList())
      .unwrap()
      .then((res) => {})
      .catch((ex) => {
        if (ex && ex.response?.status === 422) {
          showToast(
            "Error!",
            "Payment gateway provider not available right now, please try again later.",
            "error"
          );
        }
      });
  }, [token]);

  useEffect(() => {
    if (!cartInfoLoading) {
      dispatch(setState(cartInfo?.properties?.state || "Kuala Lumpur"));
    }
  }, [cartInfo, cartInfoLoading]);

  return (
    <Formik
      initialValues={checkoutForm}
      validationSchema={checkoutSchema}
      enableReinitialize={true}
      onSubmit={(values, { setFieldError }) => {
        handleSubmit(values, setFieldError);
      }}
    >
      {({ values, errors, setFieldValue, isValid }) => (
        <Form>
          <Container className="cart-form">
            <Row className="v-flex gap-5">
              {formList.map((form, formIndex) => (
                <Col key={formIndex} className="_col form">
                  <h2 className="_label cart-form-title">{form.label}</h2>
                  <p className="_label cart-form-subtitle">
                    {form.description}
                  </p>
                  {formIndex === 0 ? (
                    <Col className="w-100 v-flex gap-4 my-3">
                      {inputList.map((input, inputIndex) => (
                        <Row className="_row form" key={inputIndex}>
                          {input.map((col, colIndex) =>
                            col.prefix ? (
                              <Col className="w-100">
                                <Row
                                  className={`_input --prefix ${
                                    cartInfoLoading ? "--disabled" : ""
                                  }`}
                                >
                                  <p>+60</p>
                                  <Input
                                    key={colIndex}
                                    name={col.name}
                                    placeholder={col.label}
                                    invalid={!col.prefix}
                                    disabled={cartInfoLoading}
                                    className={
                                      cartInfoLoading ? "--disabled" : ""
                                    }
                                  />
                                </Row>
                                {errors[col.name] && (
                                  <Row className="_label error-message element _errors">
                                    {errors[col.name]}
                                  </Row>
                                )}
                              </Col>
                            ) : col.options?.length > 0 ? (
                              <Field
                                key={colIndex}
                                as={col.as}
                                name={col.name}
                                placeholder={col.label}
                                component={col.component}
                                options={col.options}
                                className={`${
                                  col.name === "state" ? "_dropdown state" : ""
                                } ${cartInfoLoading ? "--disabled" : ""}`}
                                onClick={(val) => {
                                  dispatch(setState(val));
                                }}
                              />
                            ) : (
                              <Input
                                key={colIndex}
                                as={col.as}
                                name={col.name}
                                placeholder={col.label}
                                readOnly={col.readOnly}
                                className={cartInfoLoading ? "--disabled" : ""}
                              />
                            )
                          )}
                        </Row>
                      ))}
                    </Col>
                  ) : (
                    <Col className="w-100 v-flex gap-4 my-3">
                      {paymentListLoading
                        ? Array.from(
                            { length: 3 },
                            (_, paymentLoadingIndex) => (
                              <Skeleton
                                width="100%"
                                height="52px"
                                borderRadius="0"
                                key={paymentLoadingIndex}
                              />
                            )
                          )
                        : Object.keys(paymentList).map(
                            (payment, paymentIndex) => {
                              const isExpanded =
                                expandPayment.includes(paymentIndex);

                              return (
                                <Col
                                  className={`_col payment 
                              ${isExpanded ? "--expanded pb-5" : "gap-0"}
                              pointer
                            `}
                                  key={paymentIndex}
                                  onClick={() => {
                                    setPaymentName(payment);

                                    if (paymentList[payment]?.length === 1) {
                                      handleSelectPayment(
                                        paymentList[payment],
                                        setFieldValue
                                      );
                                    }
                                  }}
                                >
                                  <Row
                                    className={`_row payment ${
                                      isExpanded ? "--border" : ""
                                    }`}
                                    onClick={() => {
                                      if (paymentList[payment]?.length > 1) {
                                        handleExpandPayment(paymentIndex);

                                        setFieldValue(
                                          "provider_channel_id",
                                          ""
                                        );
                                        setFieldValue("tenant_channel_id", "");
                                        setFieldValue(
                                          "payment_method_name",
                                          ""
                                        );
                                      }
                                    }}
                                  >
                                    <Row className="h-flex gap-4">
                                      <Icon
                                        icon={
                                          paymentName === payment
                                            ? "fluent:radio-button-16-filled"
                                            : "fluent:radio-button-16-regular"
                                        }
                                        className={`_svg radio ${
                                          paymentName === payment
                                            ? "--active"
                                            : ""
                                        }`}
                                      />
                                      <p className="_label payment-title">
                                        {payment}
                                      </p>
                                    </Row>
                                    {paymentList[payment]?.length > 1 && (
                                      <Icon
                                        icon="material-symbols-light:keyboard-arrow-right"
                                        className="_svg arrow"
                                      />
                                    )}
                                  </Row>
                                  <Col
                                    className="w-100 v-flex gap-3"
                                    style={{
                                      overflow: "hidden",
                                      opacity: isExpanded ? 1 : 0,
                                      maxHeight: isExpanded ? "1000px" : "0px",
                                      transition:
                                        "max-height 0.3s ease, opacity 0.3s ease",
                                    }}
                                  >
                                    {paymentList[payment]?.length > 1 &&
                                      paymentList[payment].map(
                                        (method, methodIndex) => {
                                          const activeMethod =
                                            values.provider_channel_id
                                              ? values.provider_channel_id ===
                                                method.provider_channel_id
                                              : values.tenant_channel_id ===
                                                method.tenant_channel_id;

                                          return (
                                            <Row
                                              className="_row method mt-1"
                                              key={methodIndex}
                                              onClick={() =>
                                                handleSelectPayment(
                                                  method,
                                                  setFieldValue
                                                )
                                              }
                                            >
                                              <Icon
                                                icon={
                                                  activeMethod
                                                    ? "fluent:radio-button-16-filled"
                                                    : "fluent:radio-button-16-regular"
                                                }
                                                className={`_svg radio ${
                                                  activeMethod ? "--active" : ""
                                                }`}
                                              />
                                              <p className="_label payment-title">
                                                {method.name}
                                              </p>
                                            </Row>
                                          );
                                        }
                                      )}
                                  </Col>
                                </Col>
                              );
                            }
                          )}
                    </Col>
                  )}
                </Col>
              ))}
            </Row>
            <Row>
              <Button
                type={!values.payment_method_name ? "button" : "submit"}
                disabled={
                  (checkoutLoading ||
                    !isValid ||
                    cartInfo?.items?.length === 0) &&
                  values.payment_method_name
                }
                className={`_button pay-now ${
                  !values.payment_method_name ? "disabled pointer-event" : ""
                }`}
                onClick={() => {
                  if (!values.payment_method_name) {
                    showToast(
                      "Almost there!",
                      "Please select a payment method before proceeding to checkout.",
                      "warning"
                    );
                  }
                }}
              >
                Pay Now
              </Button>
            </Row>
          </Container>
        </Form>
      )}
    </Formik>
  );
}
